import { jsx } from 'react/jsx-runtime';
import { createRoot } from 'react-dom/client';
import React__default from 'react';
import { Types } from './SnackbarUtils.js';
import SnackbarElement from './SnackbarElement.js';

const domContainerNode = document.createElement('div');
domContainerNode.setAttribute('id', 'snackbar');
document.body.appendChild(domContainerNode);
const refSnackBar = React__default.createRef();
const element = createRoot(domContainerNode);
element.render(jsx(SnackbarElement, { ref: refSnackBar }));
function createSnackbar(ref) {
    return {
        show(operazione) {
            var _a;
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.show(operazione);
        },
        creaOperazioneMassiva(operazione) {
            var _a;
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.creaOperazioneMassiva(operazione);
        },
        aggiornaProgressoOperazione(id, progresso) {
            var _a;
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.aggiornaProgressoOperazione(id, progresso);
        },
        terminaOperazioneMassiva(id, progresso, testoFeedback, onFeedback) {
            var _a;
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.completaOperazione(id, progresso, testoFeedback, onFeedback);
        },
        aggiungiErroreAOperazione(id, err) {
            var _a;
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.aggiungiErroreAOperazione(id, err);
        },
        inizializzaOperazioni(operazioni) {
            var _a;
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.inizializzaOperazioni(operazioni);
        },
        recuperaOperazioniMassive() {
            var _a;
            if (ref === null || ref === void 0 ? void 0 : ref.current) {
                return JSON.parse(JSON.stringify((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.state.operazioniMassive));
            }
            return [];
        },
        clear() {
            var _a;
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.clear();
        },
        Types,
        Element: ref,
    };
}
const Snackbar = createSnackbar(refSnackBar);

export { createSnackbar, Snackbar as default };
